import React from 'react';

import { EmptyState, EmptyStateProps } from '@lumapps/lumx-states/components/EmptyState';
import { mdiFormatListText } from '@lumapps/lumx/icons';
import { ColorPalette } from '@lumapps/lumx/react';
import { NavigationMapItem } from '@lumapps/navigation/types';

import { NavigationItemWizardOptionProps } from '../../types';
import { AddNavigationItem } from '../AddNavigationItem';
import { NavigationItemModalProps } from '../NavigationItemModal/NavigationItemModal';

export interface EmptyNavigationListProps {
    /** default language for the platform */
    defaultLanguage: string;
    /** list of platform languages */
    languages: string[];
    /** callback to be executed once the navigation item is created */
    onAdded?: (navItem: NavigationMapItem, buttonRef: React.Ref<HTMLElement>) => void;
    /** title for the component */
    title?: string;
    /** message for the component */
    message?: EmptyStateProps['message'];
    /** scope to be used for tracking purposes */
    scope: string;
    /** Options to be passed into wizard */
    wizardOptions?: NavigationItemWizardOptionProps['options'];
    /** Override properties for the navigation item modal */
    navigationItemModalProps?: Partial<NavigationItemModalProps>;
    /** Whether the addNavigationItem dialog is open or not */
    isAddNavigationItemOpen?: boolean;
    /** Callback to be sent when user open the modal */
    onToggleWizard?(isOpen: boolean): void;
}

/**
 * Component that will be displayed when the navigation is empty.
 * @param EmptyNavigationListProps
 */
export const EmptyNavigationList: React.FC<EmptyNavigationListProps> = ({
    title,
    message,
    defaultLanguage,
    languages,
    onAdded,
    scope,
    navigationItemModalProps,
    wizardOptions,
    isAddNavigationItemOpen,
    onToggleWizard,
}) => {
    return (
        <EmptyState
            actions={
                onAdded ? (
                    <AddNavigationItem
                        defaultLanguage={defaultLanguage}
                        languages={languages}
                        onAdded={onAdded}
                        scope={scope}
                        navigationItemModalProps={navigationItemModalProps}
                        options={wizardOptions}
                        isOpen={isAddNavigationItemOpen}
                        onToggleWizard={onToggleWizard}
                    />
                ) : undefined
            }
            iconProps={{
                icon: mdiFormatListText,
                color: ColorPalette.primary,
            }}
            title={title}
            message={message}
        />
    );
};
